import React from "react";
import { Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { ESTADOS_PALETIZACION } from "../../../../../../../../utility/constants";
const refreshIcon = require("assets/img/icons/refresh.png");

export const FiltrosIngresos = ({
    control,
    onRefresh,
    resetPage,
    estadoMultiple = false,
}) => {
    return (
        <div className="formulario-fields-row align-items-end">
            <div className="formulario-field" style={{ minWidth: "170px" }}>
                <label htmlFor="fecha_inicial" className="m-0">
                    Fecha inicial
                </label>
                <Controller
                    name="fecha_inicial"
                    control={control}
                    render={({ field }) => (
                        <DatePicker
                            selected={field.value}
                            onChange={(date) => {
                                field.onChange(date);
                                resetPage();
                            }}
                            showTimeSelect
                            timeFormat="HH:mm"
                            showPopperArrow={false}
                            dateFormat="DD/MM/YYYY HH:mm"
                            placeholderText="Fecha de inicio"
                            maxDate={control._formValues.fecha_final}
                            popperPlacement="bottom-start"
                            popperModifiers={{
                                flip: {
                                    enabled: false,
                                },
                            }}
                        />
                    )}
                />
            </div>
            <div className="formulario-field" style={{ minWidth: "170px" }}>
                <label htmlFor="fecha_final" className="m-0">
                    Fecha final
                </label>
                <Controller
                    name="fecha_final"
                    control={control}
                    render={({ field }) => (
                        <DatePicker
                            selected={field.value}
                            onChange={(date) => {
                                field.onChange(date);
                                resetPage();
                            }}
                            showTimeSelect
                            timeFormat="HH:mm"
                            showPopperArrow={false}
                            dateFormat="DD/MM/YYYY HH:mm"
                            placeholderText="Fecha final"
                            minDate={control._formValues.fecha_inicial}
                            popperPlacement="bottom-start"
                            popperModifiers={{
                                flip: {
                                    enabled: false,
                                },
                            }}
                        />
                    )}
                />
            </div>
            {estadoMultiple && (
                <div className="formulario-field" style={{ minWidth: "170px" }}>
                    <label htmlFor="estado" className="m-0">
                        Estado
                    </label>
                    <Controller
                        name="estado"
                        control={control}
                        render={({ field }) => (
                            <Select
                                {...field}
                                isClearable={true}
                                className="react-select-container"
                                backspaceRemovesValue={false}
                                isSearchable
                                options={[
                                    {
                                        value: [
                                            ESTADOS_PALETIZACION.ACEPTADO_PARCIAL,
                                            ESTADOS_PALETIZACION.ACEPTADO,
                                        ],
                                        label: "Todos",
                                    },
                                    {
                                        value: ESTADOS_PALETIZACION.ACEPTADO_PARCIAL,
                                        label: "Aceptado parcial",
                                    },
                                    {
                                        value: ESTADOS_PALETIZACION.ACEPTADO,
                                        label: "Aceptado",
                                    },
                                ]}
                                placeholder={"Seleccione..."}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                            />
                        )}
                    />
                </div>
            )}
            <img
                src={refreshIcon}
                alt="Refrescar listado"
                title="Refrescar listado"
                className="action_img mb-1"
                onClick={() => {
                    onRefresh();
                }}
            />
        </div>
    );
};
